import React, { useEffect, useState } from "react";

import i18next from 'i18next'
import { authAxios } from "../config/config";
import { toast } from "react-toastify";
import IsLoadingHOC from "../Common/IsLoadingHOC";
import { setReportFormatDate, showLimitedText } from "../Helper/helper";
import { Menu } from "@headlessui/react";
import Pagination from "../Common/Pagination";
import { useSelector } from "react-redux";
import DeleteConfirmationModel from "./Models/DeleteConfirmationModel";
import AddTrading from "./Models/AddTrading";
import { FiPlus } from "react-icons/fi";
import { IoMdMore } from "react-icons/io";
import AddOutsideJordan from "./Models/AddOutsideJordan";
import { useTranslation } from "react-i18next";
import IsLoggedinHOC from "../Common/IsLoggedInHOC";

const OutsideJordan = (props) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const { setLoading } = props;
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(5);
  const [totalPosts, setTotalPosts] = useState(5);
  const [allModel, setAllModel] = useState({
    data: [],
    showDeleteModel: false,
    showCountryModel: false,
  });
  const currentLanguage = i18next.language;

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const response = await authAxios().get(
        `/admin/outside-jordan?page=${currentPage}&limit=${postsPerPage}`
      );
      setLoading(false);
      const resData = response?.data;
      console.log(resData);
      setData(resData.data.outsideJordans);
      setTotalPosts(resData.data.totalOutsideJordans)
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    }
  };

  const handleCancel = () => {
    setAllModel({ data: [], showDeleteModel: false, showCountryModel: false });
  };

  const handleDelete = async () => {
    await authAxios()
      .delete(`/admin/outside-jordan/${allModel.data._id}`)
      .then((response) => {
        handleCancel();
        toast.success(response.data.message);
        fetchAllData();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };

  const handleAdd = async (data) => {
    await authAxios()
      .post(`/admin/outside-jordan`, data)
      .then(() => {
        fetchAllData();
        handleCancel();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };

  const handleUpdate = async (data) => {
    await authAxios()
      .put(`/admin/outside-jordan/${allModel.data._id}`, data)
      .then(() => {
        fetchAllData();
        handleCancel();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };

  useEffect(() => {
    fetchAllData();
  }, [currentPage]);

  return (
    <div className="px-[50px] py-[20px] bg-lightgray area--page pb-0">
      <div className="w-[100%] mx-auto pb-[65px]">
        <div className="flex justify-end mb-[30px] gap-[20px]">
          <button className="flex items-center max-w-[140px] border border-white bg-white text-textcolor py-[8px] px-[10px] h-[39px] rounded-[5px]">
            Total: {totalPosts || 0}
          </button>
          <button
            onClick={() => setAllModel({ data: [], showCountryModel: true })}
            className="flex items-center max-w-[160px] border border-buttonbg bg-buttonbg text-white py-[8px] px-[15px] h-[39px] rounded-[5px]">
            <FiPlus /> Add
          </button>
        </div>

        <div className="relative mt-[10px] overflow-x-auto px-[20px] py-[15px] bg-white rounded-t-[10px] h-[100vh] over--scroller area--table">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-lightcolor border-b border-textcolor">
              <tr>
                <th className="p-4 font-[400]">S.No</th>
                <th className="p-4 font-[400]">Image</th>
                <th className="p-4 font-[400]">Name</th>
                <th className="p-4 font-[400]">Description</th>
                <th className="p-4 font-[400]">Email</th>
                <th className="p-4 font-[400]">Contact Number</th>
                <th className="p-4 font-[400]">Country</th>
                <th className="p-4 font-[400]">Social Links</th>
                <th className="p-4 font-[400]">Created At</th>
                <th className="p-4 font-[400]">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item._id} className="bg-white border-b hover:bg-gray-50">
                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    {index + 1}
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    <img
                      className="w-10 h-10 rounded-full"
                      src={`${process.env.REACT_APP_IMAGE_URL}/${item.image}`}
                      alt={item.name.en}
                    />
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    {item.name[currentLanguage]}
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 text-sm max-h-[100px] ">
                    <div class='has-tooltip'>
                      <span class='tooltip rounded shadow-lg p-1 bg-gray-100 text-black -mt-8'>{item.description[currentLanguage]}</span>
                      {
                        showLimitedText(item.description[currentLanguage])
                      }
                    </div>
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    {item?.email || "N/A"}
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    {item?.contactNumber || "N/A"}
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    {item.country?.name[currentLanguage] || "N/A"}
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    <div className="flex gap-2">
                      {!(item?.facebook || item?.instagram || item?.twitter || item?.youtube || item?.linkedin) ? (
                        <>N/A</>
                      ) : (
                        <>
                          {item?.facebook && (
                            <a href={item.facebook} target="_blank" rel="noopener noreferrer" className="text-blue-600">
                              FB
                            </a>
                          )}
                          {item?.instagram && (
                            <a href={item.instagram} target="_blank" rel="noopener noreferrer" className="text-pink-600">
                              IG
                            </a>
                          )}
                          {item?.twitter && (
                            <a href={item.twitter} target="_blank" rel="noopener noreferrer" className="text-blue-400">
                              TW
                            </a>
                          )}
                          {item?.youtube && (
                            <a href={item.youtube} target="_blank" rel="noopener noreferrer" className="text-red-600">
                              YT
                            </a>
                          )}
                          {item?.linkedin && (
                            <a href={item.facebook} target="_blank" rel="noopener noreferrer" className="text-blue-600">
                              LI
                            </a>
                          )}
                        </>
                      )}



                    </div>
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    {setReportFormatDate(item.createdAt)}
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    <Menu as="div" className="relative inline-block text-left">
                      <Menu.Button className="more--icon cursor-pointer w-[30px] h-[30px] bg-lightgray rounded-[5px] flex items-center justify-center">
                        <IoMdMore />
                      </Menu.Button>
                      <Menu.Items className={`absolute ${isRTL ? "left-0" : "right-0"} z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5`}>
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              onClick={() =>
                                setAllModel({ data: item, showCountryModel: true })
                              }
                              className={`block px-4 py-2 text-sm ${active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                                }`}
                            >
                              Edit
                            </a>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              onClick={() =>
                                setAllModel({ data: item, showDeleteModel: true })
                              }
                              className={`block px-4 py-2 text-sm ${active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                                }`}
                            >
                              Delete
                            </a>
                          )}
                        </Menu.Item>
                      </Menu.Items>
                    </Menu>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPosts={totalPosts}
          paginate={paginate}
          postsPerPage={postsPerPage}
        />

        {allModel.showDeleteModel && (
          <DeleteConfirmationModel handleCancel={handleCancel} handleDelete={handleDelete} />
        )}

        {allModel.showCountryModel && (
          <AddOutsideJordan
            handleCancel={handleCancel}
            handleAdd={handleAdd}
            allModel={allModel}
            handleUpdate={handleUpdate}
          />
        )}
      </div>
    </div>
  );
};

export default IsLoggedinHOC(IsLoadingHOC(OutsideJordan));
